// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"7249c7ba","879":"b27517cc"}[chunkId] + ".chunk.js";
};